module.exports = __webpack_public_path__ + "static/media/6.d635f2a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/6.png
// module id = 935
// module chunks = 21